module.exports = __webpack_public_path__ + "static/media/file.73e9524a.png";